var DEFAULTS={config:{toolbar:{hidden:[]}},configViewer:{getVideoUrl:function(src){return"https://video.wixstatic.com/"+src.pathname}}};export{DEFAULTS};
//# sourceMappingURL=defaults.js.map
